// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IEmptyParams {
	$type?: string | undefined;
}
export class EmptyParams {
	constructor(data?: IEmptyParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	static $type: string = "CoreApi.Models.DeviceCommands.EmptyParams, ";
	$type?: string | undefined = EmptyParams.$type;
}

